<template>
  <UIDialog
    :is-open
    :size
    :title
    :z-index
    @close="handleClose"
  >
    <slot />
    <template #footer>
      <UIButtonsGroup>
        <UIButton
          label="Cancel"
          variant="gray"
          fill="outlined"
          @click="handleClose"
        />
        <UIButton
          v-for="action in actions"
          :key="action.label"
          :label="action.label"
          :variant="action.buttonVariant"
          :disabled="action.disabled"
          :loading="action.loading"
          @click="action.onClick"
        />
      </UIButtonsGroup>
    </template>
  </UIDialog>
</template>

<script setup lang="ts">

import { DialogActionsButton, DialogSize } from './utils/types'

import UIButton from '../Button/Button.vue'
import UIButtonsGroup from '../Button/ButtonsGroup.vue'
import UIDialog from './Dialog.vue'

type Props = {
  isOpen: boolean
  zIndex: number

  title?: string

  size?: DialogSize

  actions?: DialogActionsButton[]
}

type Emits = {
  close: []
}

defineProps<Props>()
const emit = defineEmits<Emits>()

const handleClose = () => {
  emit('close')
}
</script>
